import React from 'react';
import PropTypes from 'prop-types';
// import Link from 'next/link';
// import Icon from 'react-icons-kit';
import Fade from 'react-reveal/Fade';
// import { openModal, closeModal } from '@redq/reuse-modal';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
// import Button from 'reusecore/src/elements/Button';
import Image from 'reusecore/src/elements/Image';
import Container from '../../../components/UI/Container';
import {
  BannerWrapper,
} from './banner.style';
import BannerImage from '../../../assets/image/donuts/banner-image.png';

const BannerSection = ({
  row,
  contentWrapper,
  title,
  description,
  imageWrapper,
  // buttonWrapper,
  // button,
  // fillButton,
}) => {

  return (
    <BannerWrapper id="banner_section">
      {/* <TiltShape className="banner-shape" /> */}
      <Container>
        <Box {...row}>
          <Box {...contentWrapper}>
            <Heading
              {...title}
              content="Donuts"
            />
            <Text
              {...description}
              content="THINNEST | ULTRA LIGHT | SUPER COZY"
            />
          </Box>
          <Box {...imageWrapper}>
            <Fade bottom>
              {/* <VideoModal> */}
                <Image src={BannerImage} alt="banner image" />
              {/* </VideoModal> */}
            </Fade>
          </Box>
        </Box>
      </Container>
    </BannerWrapper>
  );
};

BannerSection.propTypes = {
  row: PropTypes.object,
  contentWrapper: PropTypes.object,
  discountAmount: PropTypes.object,
  discountText: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  imageWrapper: PropTypes.object,
  buttonWrapper: PropTypes.object,
  button: PropTypes.object,
  fillButton: PropTypes.object,
};

BannerSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentWrapper: {
    width: ['100%', '100%', '80%', '55%', '50%'],
    mb: '40px',
  },
  title: {
    // fontSize: ['24px', '32px', '40px', '42px', '46px'],
    fontSize: ['4.5em', '5.5em', '6.5em', '6.5em', '6.5em'],
    fontWeight: '700',
    color: '#000',
    letterSpacing: '-0.025em',
    mb: ['20px', '25px', '25px', '25px', '25px'],
    lineHeight: '1.2',
    textAlign: 'center',
  },
  description: {
    // fontSize: ['1.1em', '1.35em', '1.35em', '1.35em', '1.35em'],
    fontSize: ['15px', '16px', '16px', '16px', '16px'],
    color: '#000',
    lineHeight: '1.75',
    mb: '0',
    textAlign: 'center',
  },
  discountAmount: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '700',
    color: '#000',
    mb: 0,
    as: 'span',
    mr: '0.4em',
  },
  discountText: {
    fontSize: ['13px', '14px', '14px', '14px', '14px'],
    fontWeight: '400',
    color: '#000',
    mb: 0,
    as: 'span',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '150px'],
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'center',
    mt: '35px',
  },
  button: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '600',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    color: '#000',
    colors: 'secondary',
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
};

export default BannerSection;
